import { lazy } from 'react';

// Types
import { ClearpayButtonProps as LazyComponentProps } from './ClearpayButton.types';

// Components
import withSuspense, { lazyRetry } from '../../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "clearpayButton" */ './ClearpayButton')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'ClearpayButton');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as ClearpayButton };
